import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "asSettingModal"
}
const _hoisted_2 = { class: "asSettingModal_content" }
const _hoisted_3 = { class: "asSettingModal_name" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["selected", "value"]
const _hoisted_6 = ["data-test"]
const _hoisted_7 = ["selected"]
const _hoisted_8 = ["selected"]
const _hoisted_9 = ["onClick", "data-test"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.modelValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "asSettingModal_overlay",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "asSettingModal_close",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('settingLesson')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (option.type === 'boolean')
                ? (_openBlock(), _createElementBlock("div", {
                    class: "asSettingModal_label",
                    onClick: ($event: any) => (_ctx.checked(option)),
                    key: `checked${i}`
                  }, [
                    _createTextVNode(_toDisplayString(option.userName) + " ", 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["asSettingModal_checkbox", { '-checked': _ctx.isChecked(option.value) }])
                    }, null, 2)
                  ], 8, _hoisted_4))
                : _createCommentVNode("", true),
              (option.type === 'enum')
                ? (_openBlock(), _createElementBlock("div", {
                    class: "asSettingModal_label -select",
                    key: `select${i}`
                  }, [
                    _createTextVNode(_toDisplayString(option.userName) + " ", 1),
                    _createElementVNode("select", {
                      class: "asSettingModal_select",
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.select($event.target.value)))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(option.trainingLessonOptionValues, (value) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: `option${value.id}`,
                          selected: option.value.id === value.id,
                          value: JSON.stringify(value)
                        }, _toDisplayString(value.value), 9, _hoisted_5))
                      }), 128))
                    ], 32)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 256)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter, key) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (key === 'orientation')
                ? (_openBlock(), _createElementBlock("div", {
                    class: "asSettingModal_label -select",
                    key: `checkedFilter${key}`,
                    "data-test": `checkedFilter-${key}`
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t(`lessonTypeEnable.${key}`)) + " ", 1),
                    _createElementVNode("select", {
                      class: "asSettingModal_select",
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectOrientation($event.target.value)))
                    }, [
                      _createElementVNode("option", {
                        selected: filter === 'horizontal',
                        value: "horizontal"
                      }, _toDisplayString(_ctx.$t('lessonTypeEnable.horizontal')), 9, _hoisted_7),
                      _createElementVNode("option", {
                        selected: filter === 'vertical',
                        value: "vertical"
                      }, _toDisplayString(_ctx.$t('lessonTypeEnable.vertical')), 9, _hoisted_8)
                    ], 32)
                  ], 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("div", {
                    class: "asSettingModal_label",
                    onClick: ($event: any) => (_ctx.checkedFilter({ value: filter, key })),
                    key: `checkedFilter${key}`,
                    "data-test": `checkedFilter-${key}`
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t(`lessonTypeEnable.${key}`)) + " ", 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["asSettingModal_checkbox", { '-checked': filter }])
                    }, null, 2)
                  ], 8, _hoisted_9))
            ], 64))
          }), 256))
        ])
      ]))
    : _createCommentVNode("", true)
}